import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

/* Log environment */
let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
console.log('ENVIRONMENT: ', env);

let firebaseConfig = {};

/* Connect to firebase project test */
if (env === 'development' || env === 'test' || env === 'demo') {
	firebaseConfig = {
		apiKey: 'AIzaSyCmafJ2gJvbmROUxofoJeD8OMUFDv7sqU4',
		authDomain: 'cgl-vikarproven-test.firebaseapp.com',
		projectId: 'cgl-vikarproven-test',
		storageBucket: 'cgl-vikarproven-test.appspot.com',
		messagingSenderId: '1021575682564',
		appId: '1:1021575682564:web:a778b7dffe7c51de7ff351'
	};	
}

/* Connect to firebase: production */
if (env === 'production') {
	firebaseConfig = {
		apiKey: 'AIzaSyBZsGdCOa7-y8UwyDsguILdsNX8K-tjyZo',
		authDomain: 'cgl-vikarproven-production.firebaseapp.com',
		projectId: 'cgl-vikarproven-production',
		storageBucket: 'cgl-vikarproven-production.firebasestorage.app',
		messagingSenderId: '587938194912',
		appId: '1:587938194912:web:3675944acd34ee9178b785'
	};
}

/* Initialize firebase */
firebase.initializeApp(firebaseConfig);

export default firebase.firestore;